<template>
  <!-- USER SETTINGS -->
  <v-dialog v-model="internal" max-width="1000" overlay-opacity="0.59">
    <v-card
      data-testid="settings-modal"
      outlined
      style="background-color: #121212; min-height: 500px"
      class="pa-2"
    >
      <div class="d-flex flex-column mx-4">
        <div class="d-flex">
          <div class="mb-4 text-h5 font-weight-light">
            {{ $t("toolbar.settings.title") }}
          </div>
          <v-spacer />
          <v-btn icon @click="internal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div>
          <!-- FONTSIZE -->
          <v-col>
            <div class="text-h6 mb-2">{{ $t("toolbar.settings.selectFontSize") }}</div>
            <v-radio-group
              class="font-size-group"
              v-model="fontSizeProxy"
              @change="setFontSize"
            >
              <v-radio class="mb-0" label="SM" value="SM"></v-radio>
              <v-radio class="mb-0" label="MD" value="MD"></v-radio>
              <v-radio class="mb-0" label="LG" value="LG"></v-radio>
            </v-radio-group>
          </v-col>
        </div>
        <v-divider />
        <div>
          <!-- SPREAD TYPE -->
          <v-col v-if="isPartner || isBroker">
            <div class="text-h6 mb-2">{{ $t("toolbar.settings.selectSpreadType") }}</div>
            <v-radio-group
              class="font-size-group"
              v-model="spreadTypeProxy"
              @change="setSpreadType"
            >
              <v-radio class="mb-0" label="PIPS" value="PIPS"></v-radio>
              <v-radio class="mb-0" label="BPS" value="BPS"></v-radio>
            </v-radio-group>
          </v-col>
        </div>
        <v-divider />
        <div>
          <!-- settlements default -->
          <v-col v-if="isPartner || isBroker">
            <div class="text-h6 mb-2">
              {{ $t("toolbar.settings.selectSettlement") }}
            </div>
            <v-radio-group class="font-size-group" v-model="defaultSettlementProxy">
              <v-radio  class="mb-0" label="D0" value="d+0"></v-radio>
              <v-radio
                
                class=" mb-0"
                label="D1"
                value="d+1"
              ></v-radio>
              <v-radio
                
                class=" mb-0"
                label="D2"
                value="d+2"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </div>
        <v-divider />
        <div>
          <!-- choose time -->
          <v-col v-if="isBroker">
            <div class="text-h6 mb-2">{{ $t("toolbar.settings.selectTimer") }}</div>
              <div class="d-flex  flex-column align-start pt-3 ">
                  <v-select  v-model="defaultTimeProxy" label="Updated time (seconds)" :items="[5, 10, 15,20,25,30,35,40,45,50,55,60]" dense/>
              </div>
          </v-col>
        </div>
        <v-divider />
        <div v-if="isPartner || isBroker" class="my-5">
          <v-card
            outlined
            color="transparent"
            class="d-flex flex-column my-1 px-2"
          >
            <v-card-title>Upload logo</v-card-title>
            <v-card-text width="100" class="d-flex">
              <div
                width="100"
                class="upload-files mr-2"
                style="
                  border-bottom: 1px solid white;
                  line-height: 0.9rem;
                  cursor: pointer;
                "
                @click="$refs.fileInput.click()"
              >
                <div class="my-1 d-flex align-center justify-space-between">
                  <h5
                    :class="
                      selectedFile.wasUploaded
                        ? 'highlight-text'
                        : 'disabled-text'
                    "
                  >
                    {{ selectedFile.name ? selectedFile.name : "Upload image" }}
                  </h5>
                  <input
                    @change="handleImage"
                    type="file"
                    ref="fileInput"
                    style="display: none"
                    accept=".jpg, .jpeg, .png"
                  />
                </div>
              </div>
              <v-btn
                small
                class="mx-1"
                color="primary"
                @click="saveLogo()"
                :disabled="!selectedFile.wasUploaded"
              >
                <v-icon small class="mr-2">mdi-content-save</v-icon
                >{{ $t("instructions.save") }}</v-btn
              >
            </v-card-text>
          </v-card>

          <v-card
            v-if="isPartner"
            outlined
            color="transparent"
            class="d-flex flex-column my-1 px-2"
          >
            <v-card-title>{{
              $t("toolbar.settings.partnerInfo.whitelabel")
            }}</v-card-title>

            <v-card-text class="d-flex" style="width: 100%">
              <v-text-field
                :disabled="loadingUrl || isPartner"
                v-model="selectedUrl"
                dense
              >
                <template v-slot:append-outer>
                  <v-btn
                    small
                    color="primary"
                    :disabled="!selectedUrl || loadingUrl || isPartner"
                    @click="saveUrl"
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    {{ $t("instructions.save") }}
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-text>
          </v-card>
          <!--snackbar confirmation copy-->
          <v-snackbar
            timeout="2000"
            color="green"
            v-model="selectedFile.copiedUrlSnackbar"
          >
            {{ $t("toolbar.settings.partnerInfo.copyUrl") }}
          </v-snackbar>
        </div>

        <!-- USER INFORMATION -->
        <v-card
          v-if="!isBroker && !isPartner"
          flat
          class="pa-4 mb-2"
          style="background-color: #191919; position: relative"
        >
          <v-row>
            <v-col
              cols="12"
              sm=""
              class="ma-1"
              style="background-color: #202020"
            >
              <div class="mb-2">
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.company") }}
                </div>
                <div>{{ userInfo.companyName }}</div>
              </div>
              <div class="mb-2">
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.cnpj") }}
                </div>
                <div>{{ userInfo.cnpj }}</div>
              </div>
            </v-col>

            <v-col
              cols="12"
              sm=""
              class="ma-1"
              style="background-color: #202020"
            >
              <div class="mb-2">
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.name") }}
                </div>
                <div>{{ userInfo.companyRepresentative }}</div>
              </div>
              <div class="mb-2">
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.phone") }}
                </div>
                <div>{{ userInfo.phone }}</div>
              </div>
              <div>
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.email") }}
                </div>
                <div style="text-decoration: underline">
                  {{ userInfo.email }}
                </div>
              </div>
            </v-col>

            <v-col
              cols="12"
              sm=""
              class="ma-1"
              style="background-color: #202020"
            >
              <div>
                <div class="text-caption font-weight-bold">
                  {{ $t("toolbar.settings.userInfo.region") }}
                </div>
                <div>{{ userInfo.region }}</div>
              </div>
            </v-col>
          </v-row>

          <!-- button to edit the user information, commented for now -->
          <v-btn
            v-if="false"
            small
            color="primary"
            style="position: absolute; bottom: 16px; right: 16px"
            @click="editUserInfo()"
          >
            {{ $t("instructions.edit") }}
          </v-btn>
        </v-card>

        <!-- USER BROKER BANKLIST -->
        <v-col v-if="isBroker">
          <div class="text-h6">{{ $t("toolbar.settings.banklist") }}</div>
          <v-data-table
            :headers="settingsHeadersBroker"
            :items="banklist"
            :items-per-page="10"
            item-key="name"
            style="
              max-height: 1000px;
              overflow-y: auto;
              background-color: #121212;
            "
          >
            <template v-slot:[`item.name`]="{ item }">
              {{ item.name }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <span
                :style="{
                  color: item.selected ? '#00E676' : '#ED2B2A',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }"
              >
                {{
                  item.selected
                    ? $t("extras.on").toUpperCase()
                    : $t("extras.off").toUpperCase()
                }}
              </span>
            </template>

            <template v-slot:[`item.apikey`]="{ item }">
              <v-text-field
                v-model="item.apikey"
                hide-details
                dense
                solo
                flat
                type="number"
                class="my-2 remove-spin centered-input"
                @input="saveApikey(item.name, item.apikey)"
              ></v-text-field>
            </template>

            <template v-slot:[`item.connection`]="{ item }">
              <v-btn
                v-model="item.connection"
                color="primary"
                :disabled="!item.apikey"
                @click="connectbank(item)"
              >
                {{ $t("instructions.connect") }}
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
        <!-- USER PRO BANKLIST -->
        <v-col v-else-if="isPro">
          <div class="text-h6">{{ $t("toolbar.settings.banklist") }}</div>
          <!-- <div v-if="!isMockDataOn">
              {{ $t('toolbar.settings.noBanks') }}
            </div> -->
          <v-data-table
            :headers="settingsHeadersClient"
            :items="banklist"
            item-key="id"
            :items-per-page="10"
            style="
              max-height: 1000px;
              overflow-y: auto;
              background-color: #121212;
            "
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  data-testid="pro-bank-row"
                  :data-bank-id="item.id"
                  :style="{
                    backgroundColor: item.selected ? '#2a2a2a' : '#121212',
                  }"
                >
                  <td class="text-center">
                    <v-checkbox
                      data-testid="pro-bank-selected"
                      v-model="item.selected"
                      hide-details
                      dense
                      :disabled="!item.selected && selectedCount >= 4"
                    />
                  </td>
                  <td class="text-center">
                    <v-text-field
                      data-testid="pro-bank-limit"
                      v-model="item.limit"
                      hide-details
                      dense
                      solo
                      flat
                      type="number"
                      class="my-2 remove-spin centered-input"
                    />
                  </td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">
                    <span
                      :style="{
                        color: item.selected ? '#00E676' : '#ED2B2A',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                      }"
                    >
                      {{ item.selected ? "ON" : "OFF" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>

        <!-- button to save the banks selected and their limits by the user pro -->
        <div v-if="isPro" class="d-flex justify-end mt-2">
          <v-btn
            data-testid="pro-banklist-save"
            color="primary"
            :disabled="isBanklistSaved"
            @click="saveBanklist"
          >
            {{ $t("instructions.save") }}
          </v-btn>
        </div>
        <!-- TIMEZONE -->
        <v-col>
          <div class="text-h6 mb-2">{{ $t("toolbar.settings.selectTZ") }}</div>
          <v-radio-group v-model="timezoneProxy" @change="setTimezone">
            <v-radio label="UTC" value="UTC"></v-radio>
            <v-radio label="BRT" value="BRT"></v-radio>
          </v-radio-group>
        </v-col>

        <!-- BROKER CONTACT INFO -->
        <v-col v-if="isBroker">
          <div class="text-h6 mb-2">{{ $t("toolbar.contactInfo") }}</div>
          <div class="d-flex" style="gap: 10px">
            <v-text-field
              v-model="brokerInfo.phone"
              :label="$t('extras.phone')"
              dense
              disabled
            />
            <v-text-field
              v-model="brokerInfo.email"
              :label="$t('extras.email')"
              dense
              disabled
            />
          </div>
        </v-col>

        <!-- CHANGE PASSWORD -->
        <v-col>
          <div class="text-h6 mb-2">{{ $t("toolbar.changePassword") }}</div>
          <div class="d-flex" style="gap: 10px">
            <v-text-field
              data-testid="settings-password-input"
              :value="newPassword"
              @input="$emit('update:newPassword', $event)"
              :label="$t('extras.password')"
              type="password"
              dense
              :disabled="loadingPassword"
            >
              <template v-slot:append-outer>
                <v-btn
                  data-testid="settings-password-submit"
                  small
                  color="primary"
                  :disabled="!hasNewPassword || loadingPassword"
                  @click="savePassword"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  {{ $t("instructions.save") }}
                </v-btn>
              </template>
            </v-text-field>
          </div>
        </v-col>
        <v-col>
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" plain class="d-flex align-center">
                <v-img
                  v-if="isPtBRLocale"
                  style="height: 32px"
                  content-class="rounded-lg"
                  class="rounded-lg mr-2"
                  aspect-ratio="16/9"
                  max-width="32"
                  width="32"
                  :src="require(`../../assets/brazil_flag.png`)"
                />
                <v-img
                  v-else
                  style="height: 32px"
                  content-class="rounded-lg"
                  class="rounded-lg mr-2"
                  aspect-ratio="16/9"
                  max-width="32"
                  width="32"
                  :src="require(`../../assets/usd_flag.png`)"
                />
              </v-btn>
            </template>

            <v-list class="mx-auto">
              <v-list-item link @click="changeLanguageFn('en')">
                <v-img
                  style="height: 32px"
                  content-class="rounded-lg"
                  class="rounded-lg mr-2"
                  aspect-ratio="16/9"
                  max-width="32"
                  width="32"
                  :src="require(`../../assets/usd_flag.png`)"
                />
                <v-list-item-title> EN-US </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="changeLanguageFn('pt')">
                <v-img
                  style="height: 32px"
                  content-class="rounded-lg"
                  class="rounded-lg mr-2"
                  aspect-ratio="16/9"
                  max-width="32"
                  width="32"
                  :src="require(`../../assets/brazil_flag.png`)"
                />
                <v-list-item-title> PT-BR </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </div>
    </v-card>
  </v-dialog>

  <!-- USER INFO EDIT DIALOG, commented for now -->
  <!-- <v-dialog
        v-model="showEditDialog"
        max-width="500px"
        overlay-opacity="0.59"
        persistent
      >
      <v-card>
        <v-card-title class="headline">Edit Info</v-card-title>
          <v-card-text>
            <v-text-field v-model="editForm.companyName" label="Company"></v-text-field>
            <v-text-field v-model="editForm.cnpj" label="CNPJ"></v-text-field>
            <v-text-field v-model="editForm.companyRepresentative" label="Company Representative"></v-text-field>
            <v-text-field v-model="editForm.phone" label="Phone"></v-text-field>
            <v-text-field v-model="editForm.email" label="Email"></v-text-field>
            <v-text-field v-model="editForm.region" label="Region"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showEditDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveUserContactInfo()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
</template>

<script>
import * as utils from "../../utils.js";
export default {
  inject: ["changeLanguageFn"],
  emits: [
    "set-font-size",
    "set-timezone",
    "set-spread-type",
    "save-logo",
    "save-password",
    "handle-image",
    "save-banklist",
    "save-url",
  ],
  props: {
    value: {
      type: Boolean,
    },
    isPartner: {
      type: Boolean,
      default: false,
    },
    isBanklistSaved: {
      type: Boolean,
      default: false,
    },
    isBroker: {
      type: Boolean,
      default: true,
    },
    isPro: {
      type: Boolean,
      default: false,
    },
    loadingUrl: {
      type: Boolean,
    },
    loadingPassword: {
      type: Boolean,
      default: false,
    },
    isPtBRLocale: {
      type: Boolean,
      default: true,
    },
    selectedUrl: {
      type: String,
      default: "https://foobar.clearfxai.com/",
    },
    selectedCount:{
      type:Number
    },
    newPassword: {
      type: String,
      default: "",
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    spreadTypeSettings: {
      type: String,
    },
    fontSizeSettings: {
      type: String,
    },
    defaultTimeSettings: {
      type: Number
    },
    defaultSettlementSettings: {
      type: String,
      default: 'd+0'
    },
    selectedFile: {
      type: Object,
      default: () => ({}),
    },
    brokerInfo: {
      type: Object,
      default: () => ({}),
    },
    timezoneLocal: {
      type: String,
    },
    settingsHeadersBroker: {
      type: Array,
      default: () => [],
    },
    settingsHeadersClient: {
      type: Array,
      default: () => [],
    },
    banklist: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // A password is trimmed before it is hashed, so one of only spaces is none.
    hasNewPassword() {
      return Boolean((this.newPassword || "").trim());
    },
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    fontSizeProxy: {
      get() {
        return this.fontSizeSettings;
      },
      set(v) {
        this.$emit("set-font-size", v);
      },
    },
    defaultSettlementProxy: {
      get() {
        return this.defaultSettlementSettings
      },
      set(value) {
        this.$emit('set-default-settlement', value)
      }
    },
    defaultTimeProxy:{
      get () {
        return this.defaultTimeSettings;
      },
      set(v)
      {
        const newVal = {
          timer: v,
          id: localStorage.getItem('brokerId')
        }
        this.$emit('set-default-timer-for-rfq', newVal)
      }

    },
    spreadTypeProxy: {
      get() {
        return this.spreadTypeSettings;
      },
      set(v) {
        this.$emit("set-spread-type", v);
      },
    },
    timezoneProxy: {
      get() {
        return this.timezoneLocal;
      },
      set(v) {
        this.$emit("set-timezone", v);
      },
    },
  },
  methods: {
    setTimezone(v) {
      this.$emit("set-timezone", v);
    },
    setFontSize(v) {
      this.$emit("set-font-size", v);
    },
    saveBanklist(v) {
      this.$emit("save-banklist", v);
    },
    saveUrl(v) {
      this.$emit("save-url", v);
    },
    saveLogo() {
      this.$emit("save-logo");
    },
    setSpreadType(v) {
      this.$emit("set-spread-type", v);
    },
    savePassword() {
      this.$emit("save-password", this.newPassword);
    },
    handleImage(v) {
      this.$emit("handle-image", v);
    },
    handleSetTimerRfq(v)
    {
      //this.$emit('handle-set-timer-rfq', v)
    },
    blockNonNumeric(e){
      const allowed=['Backspace','Delete', 'ArrowLeft','ArrowRight', 'Escape'];
      if(allowed.includes(e.key)) return;
      if (!/^\d$/.test(e.key)) {
          e.preventDefault()
        }
    },
  },
};
</script>
<style scoped>
::v-deep .v-toolbar__extension {
  height: 42px !important;
}

::v-deep .v-tabs-bar {
  align-items: center;
}
::v-deep .v-toolbar__extension {
  padding: 0 !important;
}

::v-deep .font-size-group .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 2rem;
}
.ticker-wrapper {
  overflow: hidden;
  width: 650px;
  min-width: 125px;
  margin-top: 15px;
}

.ticker-track {
  display: flex;
  width: max-content;
  animation: scrollTicker linear infinite;
}

.ticker-item {
  flex-shrink: 0;
  width: 160px;
  margin-right: 8px;
}

.active-submenu {
  background-color: #1e1e1e !important;
  color: #0073ff !important;
  cursor: not-allowed;
}

.default-disabled {
  opacity: 0.4;
  pointer-events: none;
  color: #aaa !important;
}

.hoverable-menu:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.disabled-link {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}

.centered-input >>> input {
  text-align: center;
}

.remove-spin >>> input[type="number"] {
  -webkit-appearance: none; /* Chrome, Safari, Edge */
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield; /* Outros navegadores */
}

.remove-spin >>> input[type="number"]::-webkit-inner-spin-button,
.remove-spin >>> input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@keyframes scrollTicker {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}

.upload-files {
  width: 90%;
}
.disabled-text {
  color: #515151;
}
.highlight-text {
  color: white;
}

::v-deep div.v-radio.disabled.v-radio--is-disabled.theme--dark > div > i {
  color: #303030 !important;
}

::v-deep .v-btn{
  margin:0 !important;
  font-weight: bold;
}
</style>
